import { useAccount } from '../hooks';
import { AccountDetails } from './AccountDetails';
import { SubscriptionDetails } from './SubscriptionDetails';

export const AccountManagement = () => {

  const account = useAccount();

  return (
    <div className='grow grid grid-cols-2 self-stretch justify-evenly items-start p-4 gap-y-4 gap-x-16'>
      <div className='rounded-sm bg-white text-neutral-700 p-4 flex flex-col justify-between self-stretch'>
        <h2 className='text-2xl'>Your account</h2>
        { account && <AccountDetails account={account} /> }
      </div>
      <div className='rounded-sm bg-white text-neutral-700 p-4 flex flex-col justify-between'>
        <h2 className='text-2xl'>Your subscription</h2>
        { account && <SubscriptionDetails account={account} /> }
      </div>
    </div>
  );
};
